export default {
  reloadEmail: state => state.reloadEmail,
  reloadCertificate: state => state.reloadCertificate,
};
